module.exports = __webpack_public_path__ + "static/media/special-rewards-logo.3364c6fd.svg";